export default {
  name: 'rules',
  methods: {
    loadNextPage() {
      this.$router.push('/task-instructions')
    }
  }
}